
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { ReportRequestFacade } from './facade/report-request.facade';
import { ReportRequestEffects } from './effects/report-request.effects';
import { reportRequestReducer } from './reducers/report-request.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('report-requests', reportRequestReducer),
    EffectsModule.forFeature([ReportRequestEffects]),
  ],
  providers: [ReportRequestEffects, ReportRequestFacade]
})
export class ReportRequestStoreModule {}
